import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BalancePopoverComponent } from '../components/balance-popover/balance-popover.component';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class BalanceService{
  
  url: string = environment.url;
  currencySource = new Subject<any>();
  currency = this.currencySource.asObservable();

  constructor(
    private http: HttpClient,
    private popoverCtrl: PopoverController,
    private storageService: StorageService
  ) {}

  async setCurrency(){
    const currency: any = await this.storageService.get('currency');
    return currency;
  }

  async getUserBalance(ev?, avatar?, name?, isPopover?) {
    const target = ev
    return new Promise( resolve => {
      this.http.get(`${this.url}/user/balance`).subscribe(async (res: any) => {
        const resData = res.data[0];

        if (isPopover) {
          
          const popover = await this.popoverCtrl.create({
            component: BalancePopoverComponent,
            componentProps: { resData, avatar, name },
            event: target,
            cssClass: 'showStatics',
          });

          await popover.present();
        } else {
          resolve(resData);
        }
      }, async error => {        
        if(error.status === 401 && error.url === `${this.url.toLocaleLowerCase()}/user/balance`){
          
          await this.storageService.remove('token');
          await this.storageService.remove('tokenPush');
          await this.storageService.remove('userLogin');
          window.location.reload();
        };
      });
    });
  }

  async getCurrencies(){
    return new Promise((resolve, reject) => {
      this.http.get(`${this.url}/currency/index`).subscribe(res => {
        resolve(res)
      }, err => {
        reject(err);
      })  
    })
  }
}
